export default "__VITE_ASSET__6490ed80__"